import React from "react";
import { useTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Typography } from "@mui/material";

import AllPropertiesView from "./AllPropertiesView";
import SidebarResizeHandle from "../../shared/SidebarResizeHandle";
import styles from "./sideMenu.module.css";

function SideMenu({
  open,
  handleToggle,
  mapRef,
  setMarkerInfo,
  setCurrentProperties,
  selectedPortfolioId,
  width,
  onResize,
}) {
  const { t } = useTranslation();
  const hasActivePortfolio = Boolean(selectedPortfolioId);

  const renderContent = () => {
    if (!hasActivePortfolio) {
      return (
        <Typography variant="body2" color="text.secondary">
          {t("portfolioMap.noPortfolioFound", {
            defaultValue: "No portfolio found for this client yet.",
          })}
        </Typography>
      );
    }

    return (
      <AllPropertiesView
        mapRef={mapRef}
        setMarkerInfo={setMarkerInfo}
        setCurrentProperties={setCurrentProperties}
        selectedPortfolioId={selectedPortfolioId}
      />
    );
  };

  return (
    <div
      className={`${styles.container} ${open ? "" : styles.hidden}`}
      style={{ width }}
    >
      <SidebarResizeHandle onResize={onResize} />

      <IconButton onClick={handleToggle} className={styles.toggleButton}>
        {open ? <ChevronRightIcon /> : <ChevronLeftIcon />}
      </IconButton>

      <div className={styles.content}>
        {renderContent()}
      </div>
    </div>
  );
}

export default SideMenu;
